import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormControl, Select, MenuItem, InputLabel } from "@mui/material";
import RMPMTransportationTable from "./RMPMTransportationTable";
import btnDownloadIcon from "../../../Assests/download-icon.svg";
import btnSaveIcon from "../../../Assests/Save-btn.svg";
import {
  EditProductTableSuccess,
  ViewProductTableError,
  ViewProductTableStart,
  ViewProductTableSuccess,
} from "../../../Redux/Actions/InputData";
import { postRequest, putRequest } from "../../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  LONG_RMPM_TRANSPORTATION_DOWNLOAD_API,
  LONG_RMPM_TRANSPORTATION_GET_API,
  LONG_UPDATE_BULK_EDIT_API,
  LONG_UPDATE_BULK_RMPM_EDIT_API,
} from "../../../Utils/Config";
import RestoreOutlinedIcon from "@mui/icons-material/RestoreOutlined";
import axios from "axios";
import FileSaver from "file-saver";
import "./style.css";
import { useTheme } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import Snackbar from "@mui/material/Snackbar";
import Alert, { AlertProps } from "@mui/material/Alert";
import AddRowButton from "../../../Components/Common/AddRowButton";
import DeleteRowsButton from "../../../Components/Common/DeleteRowsButton";
import ConfirmationDialog from "../../../Components/Common/ConfirmationDialog";

function RMPMTransportation(props: any) {
  const childRef: any = useRef();
  const dispatch: any = useDispatch();
  const [selectVendorCode, setselectVendorCode] = useState<any>("");
  const [selectRmCode, setselectRmCode] = useState<any>("");
  const [selectRMPMType, setselectRMPMType] = useState<any>("");
  const [selectTimePeriod, setSelectTimePeriod] = useState<any>("");
  const [selectFacilitCode, setselectFacilitCode] = useState<any>("");
  const [selectRmType, setselectRmType] = useState<any>("");
  const [rowsData, setRows] = React.useState<any[]>([]);
  const [isProcessed, setIsProcessed] = React.useState(false);
  const [rmpmTypeOptions, setRMPMTypeOptions] = React.useState([]);
  const [rmCodeOptions, setrmCodeOptions] = useState<any>([]);
  const [timePeriodOptions, settimePeriodOptions] = useState<any>([]);
  const [facilityCodeOption, setfacilityCodeOption] = React.useState([]);
  const [lineOptions, setLineOptions] = useState<any>([]);
  const [getEditedValue, setEditedValue] = useState<any>([]);
  const [open, setOpen] = React.useState(false);
  const [vendorCodeOptions, setvendorCodeOptions] = React.useState([]);
  const [rmTypeOption, setRmTypeOption] = React.useState([]);

  const selectedFolderData = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderData,
  );

  let folderModuleName = selectedFolderData?.folder?.slice(0, 7);

  const [filterRequest, setFilterRequest] = React.useState([
    { key: "vendor_Code", value: "" },
    { key: "facility_Code", value: "" },
    { key: "rM_PM_MI_Type", value: "" },
    {
      key: folderModuleName === "module3" ? "rM_PM_Code" : "rM_PM_MI_Code",
      value: "",
    },
    {
      key:
        folderModuleName === "module3"
          ? "rM_PM_Description"
          : "rM_PM_MI_Description",
      value: "",
    },
    { key: "time_Period", value: "" },
  ]);

  const [isDeleteConfirmOpen, setIsDeleteConfirmOpen] = useState(false);
  const [deletedRows, setDeletedRows] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [isActionEnabled, setIsActionEnabled] = useState(false);
  const handleSelectionChange = (newSelection: any[]) => {
    setSelectedRows(newSelection);
    setIsActionEnabled(newSelection.length > 0);
  };

  const selectedUsecaseId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );

  /**Redux state */
  const selectedUsecaseeId = useSelector(
    (state: any) => state.InputDataReducers.selectedUsecaseId,
  );
  const selectedCategoryId = useSelector(
    (state: any) => state.InputDataReducers.selectedCategoryId,
  );
  const selectedFolderId = useSelector(
    (state: any) => state.InputDataReducers.selectedFolderId,
  );

  const selectedScenarioId = useSelector(
    (state: any) => state.InputDataReducers.selectedScenarioId,
  );

  const isEditPopup = useSelector(
    (state: any) => state.InputDataReducers.editPopupFlage,
  );
  const selectedTimePeriodData = useSelector(
    (state: any) => state.InputDataReducers.selectedTimePeriodData,
  );

  var VC = 0;
  var FC = 0;
  var RT = 0;
  var RC = 0;
  var TP = 0;
  var RMPMT = 0;

  const [tableName, setTableName] = useState<any>(
    "tblScenario_RMPMTransportation_LT",
  );

  useEffect(() => {
    if (folderModuleName === "module2") {
      setTableName("tblScenario_RMPMTransportation_LT_Module2");
      callTableGridApi("tblScenario_RMPMTransportation_LT_Module2");
    } else if (folderModuleName === "module3") {
      setTableName("tblScenario_RMPMTransportation_LT_Module3");
      callTableGridApi("tblScenario_RMPMTransportation_LT_Module3");
    } else if (folderModuleName === "module4") {
      setTableName("tblScenario_RMPMTransportation_LT_Module4");
      callTableGridApi("tblScenario_RMPMTransportation_LT_Module4");
    } else if (folderModuleName === "module5") {
      setTableName("tblScenario_RMPMTransportation_LT_Module5");
      callTableGridApi("tblScenario_RMPMTransportation_LT_Module5");
    } else if (folderModuleName === "module6") {
      setTableName("tblScenario_RMPMTransportation_LT_Module6");
      callTableGridApi("tblScenario_RMPMTransportation_LT_Module6");
    } else {
      setTableName("tblScenario_RMPMTransportation_LT");
      callTableGridApi("tblScenario_RMPMTransportation_LT");
    }
  }, [folderModuleName, selectedScenarioId]);

  const handleChangeSelectVendorCode = (event: any) => {
    setselectFacilitCode("");
    setselectRmType("");
    setselectRmCode("");
    setSelectTimePeriod("");
    setselectRMPMType("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectVendorCode(value);
    filterRequest[0].value = value;
    callTableGridApi();
    VC = 1;
    FC = 0;
    RT = 0;
    RC = 0;
    TP = 0;
    RMPMT = 0;
  };

  const handleChangeSelectFacilityCode = (event: any) => {
    setselectRmType("");
    setselectRmCode("");
    setSelectTimePeriod("");
    setselectRMPMType("");
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectFacilitCode(value);
    filterRequest[1].value = value;
    callTableGridApi();
    VC = 1;
    FC = 1;
    RT = 0;
    RC = 0;
    TP = 0;
    RMPMT = 0;
  };

  const handleChangeSelectRmType = (event: any) => {
    setSelectTimePeriod("");
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectRmType(value);
    filterRequest[4].value = value;
    callTableGridApi();
    VC = 1;
    FC = 1;
    RT = 1;
    RC = 1;
    TP = 0;
    RMPMT = 1;
  };

  const handleChangeSelectRmCode = (event: any) => {
    setselectRmType("");
    setSelectTimePeriod("");
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectRmCode(value);
    filterRequest[3].value = value;
    callTableGridApi();
    VC = 1;
    FC = 1;
    RT = 0;
    RC = 1;
    TP = 0;
    RMPMT = 1;
  };

  const handleChangeSelectRMPMType = (event: any) => {
    setselectRmType("");
    setselectRmCode("");
    setSelectTimePeriod("");
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    filterRequest[5].value = "";
    const {
      target: { value },
    } = event;
    setselectRMPMType(value);
    filterRequest[2].value = value;
    callTableGridApi();
    VC = 1;
    FC = 1;
    RT = 0;
    RC = 0;
    TP = 0;
    RMPMT = 1;
  };

  const handleChangeSelectTimePeriod = (event: any) => {
    VC = 1;
    FC = 1;
    RT = 1;
    RC = 1;
    TP = 1;
    RMPMT = 1;
    const {
      target: { value },
    } = event;
    setSelectTimePeriod(value);
    filterRequest[5].value = value;
    callTableGridApi();
  };

  const handleDownload = (e: any) => {
    downloadXLSFile();
  };

  const downloadXLSFile = async () => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    const requestParam = {
      usecaseId: 0,
      category_id: 0,
      folder_id: selectedFolderId,
      scenario_id: selectedScenarioId,
      table: tableName,
      time_period: "string",
      filter: filterList,
    };
    // const requestParam = { "folder_id": selectedFolderId, "scenario_id": selectedScenarioId, "table": "tblManufacturing1Data", "filter": filterList };
    let updateGrid = "";
    if (folderModuleName === "module5") {
      updateGrid =
        LONG_RMPM_TRANSPORTATION_DOWNLOAD_API + "module5datadownload";
    } else {
      updateGrid = LONG_RMPM_TRANSPORTATION_DOWNLOAD_API + "datadownload";
    }
    const urls = API_BASE_URL + updateGrid;
    axios({
      url: urls,
      method: "post",
      responseType: "arraybuffer",
      headers: { "Content-Type": "application/json;" },
      data: requestParam,
    }).then((response) => {
      let blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver(blob, Date.now() + ".xlsx");
    });
  };

  useEffect(() => {
    callTableGridApi();
  }, [
    selectedUsecaseId,
    selectedCategoryId,
    selectedFolderId,
    selectedScenarioId,
    selectedTimePeriodData,
  ]);

  const callTableGridApi = (selectedTable?: any) => {
    let timePeriodValues =
      selectedTimePeriodData !== undefined &&
      selectedTimePeriodData &&
      selectedTimePeriodData !== "Time Period" &&
      selectedTimePeriodData?.length > 0 &&
      selectedTimePeriodData[0] !== "Time Period" &&
      selectedTimePeriodData !== ""
        ? selectedTimePeriodData.join(",")
        : "";
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    console.log(selectedScenarioId, "scenario2");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId
        : selectedScenarioId;
    const requestParam = {
      time_period: timePeriodValues,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: selectedTable ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
    };

    dispatch(ViewProductTableStart());
    let updateGrid = "";
    if (folderModuleName === "module5") {
      updateGrid = LONG_RMPM_TRANSPORTATION_GET_API + "module5dataall";
    } else {
      updateGrid = LONG_RMPM_TRANSPORTATION_GET_API + "dataall";
    }
    const urls = API_BASE_URL + updateGrid;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          setIsProcessed(true);
          setRows(response.data);
          if (VC === 0)
            setvendorCodeOptions(loadvendorCodeOptions(response.data));
          if (FC === 0) {
            setfacilityCodeOption(loadFacilityCode(response.data));
          }
          if (RMPMT === 0) {
            setRMPMTypeOptions(loadRMPMTypeOptions(response.data));
          }
          if (RT === 0)
            setRmTypeOption(
              folderModuleName === "module3"
                ? loadRmType(response.data)
                : loadDescriptionOptions(response.data),
            );
          if (RC === 0)
            setrmCodeOptions(
              folderModuleName === "module3"
                ? loadRmCode(response.data)
                : loadCodeOptions(response.data),
            );
          if (TP === 0) settimePeriodOptions(loadTimePeriod(response.data));
          dispatch(ViewProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
        dispatch(ViewProductTableError(error));
      });
  };

  const loadvendorCodeOptions = (data: any) => {
    const vendorCodeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = vendorCodeOptions.find((obj: any) => {
        return obj.vendor_Code === item.vendor_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        vendorCodeOptions.push({ id: item.id, vendor_Code: item.vendor_Code });
      }
    });
    return vendorCodeOptions;
    //setFactoryOptions(factoryOptions);
  };

  const loadRMPMTypeOptions = (data: any) => {
    const rmpmTypeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = rmpmTypeOptions.find((obj: any) => {
        return obj.rM_PM_MI_Type === item.rM_PM_MI_Type;
      });
      if (filteredItem === undefined || filteredItem == null) {
        rmpmTypeOptions.push({
          id: item.id,
          rM_PM_MI_Type: item.rM_PM_MI_Type,
        });
      }
    });
    return rmpmTypeOptions;
  };

  const loadDescriptionOptions = (data: any) => {
    const descriptionOptions: any = [];
    data.map((item: any) => {
      const filteredItem = descriptionOptions.find((obj: any) => {
        return obj.rM_PM_MI_Description === item.rM_PM_MI_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        descriptionOptions.push({
          id: item.id,
          rM_PM_MI_Description: item.rM_PM_MI_Description,
        });
      }
    });
    return descriptionOptions;
    //setVendorCodeOptions(vendorCodeOptions);
  };

  const loadFacilityCode = (data: any) => {
    const facilityCodeOption: any = [];
    data.map((item: any) => {
      const filteredItem = facilityCodeOption.find((obj: any) => {
        return obj.facility_Code === item.facility_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        facilityCodeOption.push({
          id: item.id,
          facility_Code: item.facility_Code,
        });
      }
    });
    return facilityCodeOption;
  };

  const loadCodeOptions = (data: any) => {
    console.log(data, "basepack");
    const codeOptions: any = [];
    data.map((item: any) => {
      const filteredItem = codeOptions.find((obj: any) => {
        return obj.rM_PM_MI_Code === item.rM_PM_MI_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        codeOptions.push({ id: item.id, rM_PM_MI_Code: item.rM_PM_MI_Code });
      }
    });
    return codeOptions;
  };

  const loadRmType = (data: any) => {
    const rmTypeOption: any = [];
    data.map((item: any) => {
      const filteredItem = rmTypeOption.find((obj: any) => {
        return obj.rM_PM_Description === item.rM_PM_Description;
      });
      if (filteredItem === undefined || filteredItem == null) {
        rmTypeOption.push({
          id: item.id,
          rM_PM_Description: item.rM_PM_Description,
        });
      }
    });
    return rmTypeOption;
  };

  const loadRmCode = (data: any) => {
    const rmCodeOption: any = [];
    data.map((item: any) => {
      const filteredItem = rmCodeOption.find((obj: any) => {
        return obj.rM_PM_Code === item.rM_PM_Code;
      });
      if (filteredItem === undefined || filteredItem == null) {
        rmCodeOption.push({ id: item.id, rM_PM_Code: item.rM_PM_Code });
      }
    });
    return rmCodeOption;
  };

  const loadTimePeriod = (data: any) => {
    const timePeriodOption: any = [];
    data.map((item: any) => {
      const filteredItem = timePeriodOption.find((obj: any) => {
        return obj.time_Period === item.time_Period;
      });
      if (filteredItem === undefined || filteredItem == null) {
        timePeriodOption.push({ id: item.id, time_Period: item.time_Period });
      }
    });
    return timePeriodOption;
  };

  const getfiltersApi = (tableeName?: string) => {
    const filterList = filterRequest.filter((elem: any) => elem.value != "");
    let scenarioId =
      selectedScenarioId?.scenario_id !== undefined &&
      selectedScenarioId?.scenario_id !== ""
        ? selectedScenarioId?.scenario_id
        : selectedScenarioId;
    const requestParam = {
      usecaseId: selectedUsecaseeId,
      category_id: selectedCategoryId,
      folder_id: selectedFolderId,
      scenario_id: scenarioId,
      table: tableeName ?? tableName,
      ispagination: 1,
      page: 1,
      pagesize: 100,
      filter: filterList,
      time_period: "",
    };

    dispatch(ViewProductTableStart());
    let updateGrid = "";
    if (folderModuleName === "module5") {
      updateGrid = LONG_RMPM_TRANSPORTATION_GET_API + "module5dataall";
    } else {
      updateGrid = LONG_RMPM_TRANSPORTATION_GET_API + "dataall";
    }
    const urls = API_BASE_URL + updateGrid;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    postRequest(urls, requestParam, header, {})
      .then((response) => {
        if (response.status === 200 && response.data) {
          console.log(response.data, "response");
          setvendorCodeOptions(loadvendorCodeOptions(response.data));
          setfacilityCodeOption(loadFacilityCode(response.data));
          setRMPMTypeOptions(loadRMPMTypeOptions(response.data));
          setRmTypeOption(
            folderModuleName === "module3"
              ? loadRmType(response.data)
              : loadDescriptionOptions(response.data),
          );
          setrmCodeOptions(
            folderModuleName === "module3"
              ? loadRmCode(response.data)
              : loadCodeOptions(response.data),
          );
          settimePeriodOptions(loadTimePeriod(response.data));
        }
      })
      .catch((error) => {
        dispatch(ViewProductTableError(error));
      });
  };

  // useEffect(() => {
  //   callTableGridApi();
  //   getfiltersApi();
  // }, [
  //   tableName,
  //   selectedUsecaseId,
  //   selectedCategoryId,
  //   selectedFolderId,
  //   selectedScenarioId,
  // ]);

  const handleRestoreClicked = (e: any) => {
    setselectVendorCode("");
    setselectFacilitCode("");
    setselectRmCode("");
    setselectRmType("");
    setSelectTimePeriod("");
    filterRequest[0].value = "";
    filterRequest[1].value = "";
    filterRequest[2].value = "";
    filterRequest[3].value = "";
    filterRequest[4].value = "";
    callTableGridApi(tableName);
  };

  // bulk edit

  const handleClearEditData = (val: any) => {
    console.log(val, "edited array");
  };

  const isEditEnabled = useSelector(
    (state: any) => state.InputDataReducers.editFilterEnable,
  );

  const handleFetchEditData = (val: any) => {
    setEditedValue(val);
  };

  const handleEditSave = (e: any) => {
    const requiredFields = [
      "vendor_Code",
      "vendor_Description",
      "facility_Code",
      "facility_Description",
      // "rM_PM_Code",
      // "rM_PM_Description",
      "time_Period",
      "min_Capacity",
      "max_Capacity",
      "min_SOB_Perc",
      "max_SOB_Perc",
      "distance",
      "cpt",
      "lead_Time",
      "cO2",
    ];
    const allMissingFields = new Set<string>();
    getEditedValue.forEach((row: any) => {
      requiredFields.forEach((field) => {
        const value = row[field];
        if (value === undefined || value === null || value === "") {
          // Convert field name to readable format
          const fieldName = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase());
          allMissingFields.add(fieldName);
        }
      });
    });

    if (allMissingFields.size > 0) {
      // Convert Set to Array and join
      const missingFieldsList = Array.from(allMissingFields).join(", ");

      setSnackbar({
        children: `Please fill the required fields: ${missingFieldsList}`,
        severity: "error",
      });
      return; // Prevent the save operation
    }

    handleClickOpen();
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAddRow = () => {
    setRows((prev: any) => {
      const emptyRow = {
        id: new Date().getTime(),
        folder_Id: selectedFolderId,
        scenario_id: selectedScenarioId,
        vendor_Code: "",
        vendor_Description: "",
        facility_Code: "",
        facility_Description: "",
        rM_PM_Code: "",
        rM_PM_Description: "",
        time_Period: "",
        min_Capacity: 0,
        max_Capacity: 0,
        min_SOB_Perc: 0,
        max_SOB_Perc: 0,
        distance: "",
        cpt: 0,
        lead_Time: "",
        cO2: "",
        isNew: true,
      };
      return prev.length > 0 ? [...prev, emptyRow] : prev;
    });
  };

  const handleDeleteRows = () => {
    if (!selectedRows.length) return;
    setIsDeleteConfirmOpen(true);
  };

  const handleConfirmDeleteRows = () => {
    const updatedRows: any[] = [];
    const rowsToDelete: any[] = [];

    rowsData.forEach((row: any) => {
      if (selectedRows.includes(row.id)) {
        const updated = {
          ...row,
          folder_id: 0,
          folder_Id: 0,
          scenario_id: 0,
          isDelete: true,
        };
        rowsToDelete.push(updated);
      } else {
        updatedRows.push(row);
      }
    });

    setRows(updatedRows);

    if (rowsToDelete.length > 0) {
      // Store deleted rows separately
      setDeletedRows((prev: any[]) => [...prev, ...rowsToDelete]);

      setIsDeleteConfirmOpen(false);
      setSelectedRows([]);
      setIsActionEnabled(false);

      const dataToSave =
        getEditedValue && getEditedValue.length > 0
          ? [
              ...getEditedValue.filter(
                (row: any) => row && Object.keys(row).length > 0,
              ),
              ...rowsToDelete,
            ]
          : rowsToDelete;

      handleAgree(dataToSave, "Record deleted successfully");
    } else {
      setIsDeleteConfirmOpen(false);
    }
  };

  const handleAgree = (dataToSave: any[], successMessage: string) => {
    const transformedRows = dataToSave.map((row: any) => {
      if (row.isNew) {
        const { isNew, ...rest } = row;
        rest.id = 0;
        return rest;
      } else if (row.isDelete) {
        const { isDelete, ...rest } = row;
        rest.folder_id = 0;
        rest.Scenario_Id = 0;
        return rest;
      }

      return row;
    });
    let updateUrl = "";
    if (folderModuleName === "module5") {
      updateUrl = LONG_UPDATE_BULK_RMPM_EDIT_API + "rmpmmitransportationbyids";
    } else {
      updateUrl = LONG_UPDATE_BULK_RMPM_EDIT_API + "rmpmtransportbyids";
    }
    const urls = API_BASE_URL + updateUrl;
    const header = {
      accept: "application/json",
      "Content-Type": "application/json",
    };
    const payload = {
      moduleKey: Number(folderModuleName?.slice(-1)),
      data: transformedRows,
    };

    putRequest(urls, payload, header, {})
      .then((response) => {
        if (response.status == 200) {
          getfiltersApi(tableName);
          setSnackbar({
            children: successMessage,
            severity: "success",
          });
          handleClose();
          childRef?.current?.ClearEditedData();
          dispatch(EditProductTableSuccess(response.data));
        }
      })
      .catch((error) => {
        setSnackbar({
          children: "Something went wrong please try again!",
          severity: "error",
        });
        handleClose();
      });
    // setTimeout(() => {
    //   props?.onClose();
    // }, 200);
  };

  // bulk edit

  const [snackbar, setSnackbar] = React.useState<Pick<
    AlertProps,
    "children" | "severity"
  > | null>(null);

  const handleCloseSnackbar = () => setSnackbar(null);

  return (
    <>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        className="Dialogbox-display"
      >
        <DialogTitle
          id="responsive-dialog-title"
          className="responsive-dialog-title-txt"
        >
          {"Confirmation for Edit"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="md-alert-clr">
            {getEditedValue.length > 0
              ? "Do you want to submit the edited RM Transportation table data?"
              : "Please Edit any value to save!"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {getEditedValue.length > 0 ? (
            <>
              <Button className="modal-btn-b" autoFocus onClick={handleClose}>
                No
              </Button>
              <Button
                className="modal-btn-b"
                onClick={() =>
                  handleAgree(getEditedValue, "Successfully saved")
                }
                autoFocus
              >
                Yes
              </Button>
            </>
          ) : (
            <Button className="modal-btn-b" autoFocus onClick={handleClose}>
              Ok
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        open={isDeleteConfirmOpen}
        onClose={() => setIsDeleteConfirmOpen(false)}
        onConfirm={handleConfirmDeleteRows}
        title="Confirmation for Delete"
        page="Shift And Changeover"
        confirmText="Yes"
        cancelText="No"
        fullScreen={fullScreen}
      />
      <div className="Compare">
        <div className="filter-section">
          <div className="page-title">
            <h3>RMPM Transportation</h3>
            <span title="Reset">
              <RestoreOutlinedIcon
                className="restoreIcon"
                onClick={(e) => handleRestoreClicked(e)}
              />
            </span>
          </div>
        </div>
        <div className="filter-section">
          <div className="filters">
            <AddRowButton
              isEditEnabled={isEditEnabled && !isActionEnabled}
              handleAddRow={handleAddRow}
            />
            <DeleteRowsButton
              isEditEnabled={isEditEnabled && isActionEnabled}
              handleDeleteRows={handleDeleteRows}
            />
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Factory</InputLabel> */}
                <Select
                  id="simple-select-1"
                  value={selectVendorCode}
                  placeholder="Select Factory"
                  onChange={handleChangeSelectVendorCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Vendor Code</em>
                  </MenuItem>
                  {vendorCodeOptions?.map((d: any) => {
                    // return (<MenuItem key={d} value={d.factory}>{d.factory}</MenuItem>)
                    return (
                      <MenuItem key={d} value={d.vendor_Code}>
                        {d.vendor_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Cascade</InputLabel> */}
                <Select
                  id="simple-select-2"
                  value={selectFacilitCode}
                  placeholder="Select Cascade"
                  onChange={handleChangeSelectFacilityCode}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Facility Code</em>
                  </MenuItem>
                  {facilityCodeOption.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.facility_Code}>
                        {d.facility_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {folderModuleName === "module5" && (
              <>
                <div className="filter-item">
                  <FormControl
                    fullWidth
                    className="selectDropdown ddoverlap-fix"
                  >
                    {/* <InputLabel>Basepack</InputLabel> */}
                    <Select
                      id="simple-select-4"
                      value={selectRMPMType}
                      placeholder="Select Basepack"
                      onChange={handleChangeSelectRMPMType}
                      // renderValue={(selectBasepack: any) => selectBasepack}
                      className="select-short-term"
                      inputProps={{ "aria-label": "Without label" }}
                      displayEmpty
                    >
                      <MenuItem value="">
                        <em>RMPM Type</em>
                      </MenuItem>
                      {rmpmTypeOptions?.map((d: any) => {
                        return (
                          <MenuItem key={d} value={d.rM_PM_MI_Type}>
                            {d.rM_PM_MI_Type}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Basepack</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectRmCode}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectRmCode}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RMPM Code</em>
                  </MenuItem>
                  {rmCodeOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.rM_PM_Code || d.rM_PM_MI_Code}>
                        {d.rM_PM_Code || d.rM_PM_MI_Code}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Line</InputLabel> */}
                <Select
                  id="simple-select-3"
                  value={selectRmType}
                  placeholder="Select Line"
                  onChange={handleChangeSelectRmType}
                  // renderValue={(selectLine: any) => selectLine}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>RMPM Description</em>
                  </MenuItem>
                  {rmTypeOption?.map((d: any) => {
                    return (
                      <MenuItem
                        key={d}
                        value={d.rM_PM_Description || d.rM_PM_MI_Description}
                      >
                        {d.rM_PM_Description || d.rM_PM_MI_Description}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            <div className="filter-item">
              <FormControl fullWidth className="selectDropdown ddoverlap-fix">
                {/* <InputLabel>Basepack</InputLabel> */}
                <Select
                  id="simple-select-4"
                  value={selectTimePeriod}
                  placeholder="Select Basepack"
                  onChange={handleChangeSelectTimePeriod}
                  // renderValue={(selectBasepack: any) => selectBasepack}
                  className="select-short-term"
                  inputProps={{ "aria-label": "Without label" }}
                  displayEmpty
                >
                  <MenuItem value="">
                    <em>Time Period</em>
                  </MenuItem>
                  {timePeriodOptions?.map((d: any) => {
                    return (
                      <MenuItem key={d} value={d.time_Period}>
                        {d.time_Period}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
            {isEditEnabled && isEditPopup && (
              <FormControl fullWidth>
                <div
                  className="content-save-btn3"
                  onClick={(e) => handleEditSave(e)}
                >
                  <img src={btnSaveIcon} alt="" /> <span> Save</span>
                </div>
              </FormControl>
            )}

            <div className="filter-item">
              <FormControl fullWidth>
                <div
                  className={`content-download-btn ${
                    isActionEnabled ? "disabled" : ""
                  }`}
                  onClick={(e) => handleDownload(e)}
                >
                  <img src={btnDownloadIcon} alt="" /> <span> Download</span>
                </div>
              </FormControl>
            </div>
          </div>
        </div>
      </div>
      <div>
        <RMPMTransportationTable
          ref={childRef}
          isProcessed={isProcessed}
          rowsData={rowsData}
          handleGetEditData={handleFetchEditData}
          handleClearEditData={handleClearEditData}
          setRows={setRows}
          handleSelectionChange={handleSelectionChange}
          selectedRows={selectedRows}
        />
        {!!snackbar && (
          <Snackbar
            open
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={handleCloseSnackbar}
            autoHideDuration={6000}
          >
            <Alert {...snackbar} onClose={handleCloseSnackbar} />
          </Snackbar>
        )}
      </div>
    </>
  );
}

export default RMPMTransportation;
